module.exports = __webpack_public_path__ + "assets/prev-white.svg?ver=79b9c1f0";